module.exports = __webpack_public_path__ + "static/media/ad.e2990f5d.svg";